import {
  deleteV1DealerIdBorrowerBorIdAssetAsstId,
  getV1DealerIdBorrowerBorIdAssets,
  postV1DealerIdBorrowerBorIdAsset,
  putV1DealerIdBorrowerBorIdAssetAsstIdUpdateAsset,
  type DtoCreateAssetReq,
  type DtoUpdateAssetReq,
} from "@porchpass/api-client";
import {
  assertApiSuccess,
  assertApiSuccessNoContent,
} from "../utils/assertApiSuccess";
import { EMPTY_REQUEST_BODY } from "./constants";
import { lazyDealerId, requireBorrowerId, type DomainIds } from "./types";

export function createAssetsDomain(ids: DomainIds) {
  const getDealerId = lazyDealerId(ids);

  return {
    getAssets: async (borrowerId?: string) => {
      const borId = requireBorrowerId(borrowerId ?? ids.borrowerId);
      const response = await getV1DealerIdBorrowerBorIdAssets(
        getDealerId(),
        borId,
        EMPTY_REQUEST_BODY,
      );
      return assertApiSuccess(response);
    },

    createAsset: async (body: DtoCreateAssetReq, borrowerId?: string) => {
      const borId = requireBorrowerId(borrowerId ?? ids.borrowerId);
      const response = await postV1DealerIdBorrowerBorIdAsset(
        getDealerId(),
        borId,
        body,
      );
      return assertApiSuccess(response);
    },

    updateAsset: async (
      assetId: string,
      body: DtoUpdateAssetReq,
      borrowerId?: string,
    ) => {
      const borId = requireBorrowerId(borrowerId ?? ids.borrowerId);
      const response = await putV1DealerIdBorrowerBorIdAssetAsstIdUpdateAsset(
        getDealerId(),
        borId,
        assetId,
        body,
      );
      return assertApiSuccess(response);
    },

    deleteAsset: async (assetId: string, borrowerId?: string) => {
      const borId = requireBorrowerId(borrowerId ?? ids.borrowerId);
      const response = await deleteV1DealerIdBorrowerBorIdAssetAsstId(
        getDealerId(),
        borId,
        assetId,
        EMPTY_REQUEST_BODY,
      );
      assertApiSuccessNoContent(response);
    },
  };
}
